function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", {
  id: "icon-radio-active_svg__radio-icon-title"
}, "Radio-ausgew\xE4hlt-Icon");

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "icon-radio-active_svg__radio-icon-desc"
}, "Kreis mit Punkt in der Mitte");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon-radio-active_svg__icon-radio",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "icon-radio-active_svg__circle-outline",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  id: "icon-radio-active_svg__circle-filled",
  cx: 12,
  cy: 12,
  r: 11.5,
  fill: "#fff",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "icon-radio-active_svg__point",
  fillRule: "nonzero",
  cx: 12,
  cy: 12,
  r: 5
}));

function SvgIconRadioActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "aria-labelledby": "radio-icon-title radio-icon-desc"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHJvbGU9ImltZyIgYXJpYS1sYWJlbGxlZGJ5PSJyYWRpby1pY29uLXRpdGxlIHJhZGlvLWljb24tZGVzYyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZSBpZD0icmFkaW8taWNvbi10aXRsZSI+UmFkaW8tYXVzZ2V3w6RobHQtSWNvbjwvdGl0bGU+CiAgICA8ZGVzYyBpZD0icmFkaW8taWNvbi1kZXNjIj5LcmVpcyBtaXQgUHVua3QgaW4gZGVyIE1pdHRlPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHN0eWxlPgogICAgICAgICAgICAuY2xzLTEgewogICAgICAgICAgICAgICAgZmlsbDogI0ZGRjsKICAgICAgICAgICAgICAgIGZpbGwtcnVsZTogbm9uemVybzsKICAgICAgICAgICAgfQogICAgICAgIDwvc3R5bGU+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iaWNvbi1yYWRpbyIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBpZD0iY2lyY2xlLW91dGxpbmUiIGN4PSIxMiIgY3k9IjEyIiByPSIxMiI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBjbGFzcz0iY2xzLTEiIGlkPSJjaXJjbGUtZmlsbGVkIiBjeD0iMTIiIGN5PSIxMiIgcj0iMTEuNSI+PC9jaXJjbGU+CiAgICAgICAgPGNpcmNsZSBpZD0icG9pbnQiIGZpbGwtcnVsZT0ibm9uemVybyIgY3g9IjEyIiBjeT0iMTIiIHI9IjUiPjwvY2lyY2xlPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconRadioActive as ReactComponent };